<a routerLink="/notifications" class="notification-link">
    <nz-badge [nzCount]="notificationCount()">
        <span nz-icon nzType="bell" nzTheme="outline" class="notification-icon"></span>
    </nz-badge>
</a>